import { useState } from 'react';

// Hooks
import { useGlobalInfo } from '@/hooks/context/useGlobalInfo';
import useUser from '@/hooks/swr/useUser';
import useSocialProfilesAuthStatus from '@/utils/hooks/swr/useSocialProfilesAuthStatus';

// Components
import { SwitchRightMenu } from '@/components/composite/SocialProfiles/SocialProfileGroupMenu/Components/SwitchRightMenu';
import { GroupsMenu } from '@/components/composite/SocialProfiles/SocialProfileGroupMenu/Components/MenuContent/Groups';
import { GroupMenu } from '@/components/composite/SocialProfiles/SocialProfileGroupMenu/Components/MenuContent/Group';
import { SocialProfilesMenu } from '@/components/composite/SocialProfiles/SocialProfileGroupMenu/Components/MenuContent/SocialProfiles';

function GroupMenuContent() {
    const { globalInfo } = useGlobalInfo();
    const [initialSocialProfilePosition, setInitialSocialProfilePosition] = useState<number>(0);

    if (globalInfo.menuSelectedGroupOpen) {
        return (
            <GroupMenu
                group={globalInfo.group.activeGroup}
                setInitialSocialProfilePosition={setInitialSocialProfilePosition}
                initialSocialProfilePosition={initialSocialProfilePosition}
            />
        );
    }

    return <GroupsMenu />;
}

function SocialProfilesMenuContent() {
    const { globalInfo } = useGlobalInfo();
    const [initialSocialProfilePosition, setInitialSocialProfilePosition] = useState<number>(0);

    // toggle on social profiles but no social profile selected
    if (globalInfo.group.activeGroup) {
        return (
            <SocialProfilesMenu
                data-testid="social-profiles-menu-no-active-item"
                hasActiveItem={false}
                initialSocialProfilePosition={initialSocialProfilePosition}
                setInitialSocialProfilePosition={setInitialSocialProfilePosition}
            />
        );
    }

    return (
        <SocialProfilesMenu
            data-testid="social-profiles-menu-active-item"
            initialSocialProfilePosition={initialSocialProfilePosition}
            setInitialSocialProfilePosition={setInitialSocialProfilePosition}
        />
    );
}

function MenuContent() {
    const { globalInfo } = useGlobalInfo();
    useSocialProfilesAuthStatus();

    if (globalInfo.menuGroupActive) {
        return <GroupMenuContent />;
    }

    return <SocialProfilesMenuContent />;
}

export function SocialProfileGroupMenu() {
    const { user } = useUser({
        revalidateOnMount: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });

    if (!user?.subscribed_or_trial) {
        return null;
    }

    return (
        <div className={'flex flex-col justify-center space-y-m'}>
            <MenuContent />
            <SwitchRightMenu />
        </div>
    );
}
